import {observer} from 'mobx-react';
import {Panel, Button, EmployeeNameWithAvatar} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {calendarDate} from 'shared/tools';
import {t} from 'shared/core';
import {urls} from 'main/tools';
import ChangesForUpdate from './ChangesForUpdate';

const PayrollUpdateForEmployee = observer(({uiState, update}) => {
  return (
    <Panel>
      <Panel.Header title={t(`models.payroll_updates.actions.${update.action}`)}>
        <Button
          onClick={() => uiState.updatePayrollUpdateStatus(update)}
          size='sm'
          trait='default'
        >
          <FormattedMessage id={`payroll_updates.actions.${update.status}`}/>
        </Button>
      </Panel.Header>
      <div className='flex'>
        <div className='col-4'>
          <EmployeeNameWithAvatar
            employee={update.employee}
            href={urls.EMPLOYEE.with(update.employee.id)}
          />
          <div className='jumbo mt1'>{`${update.employee.location.name}${update.employee.department ? ` · ${update.employee.department.name}` : ''}`}</div>
        </div>
        <div className='col-8'>
          <ChangesForUpdate update={update}/>
        </div>
      </div>
    </Panel>
  );
});

const PayrollUpdateDigest = observer(({uiState, isUpdating, payrollUpdate}) => {
  return (
    <Panel.Stack className='mb2' key={payrollUpdate.date}>
      <div className='relative'>
        <div className={`${isUpdating ? 'TableOverlay m0-important' : ''}`}></div>
        <Panel>
          <Panel.Header title={calendarDate(payrollUpdate.date)}/>
        </Panel>
        {payrollUpdate.items.map(update => <PayrollUpdateForEmployee key={update.id} uiState={uiState} update={update}/>)}
      </div>
    </Panel.Stack>
  );
});

export default PayrollUpdateDigest;
